import React from "react";

const ThemeSpinner = ({ className }) => {
  return <div className={`theme-spinner ${className}`}></div>;
};

export default ThemeSpinner;
